import { Message } from 'element-ui';
import VueCookies from 'vue-cookie';
import axios from 'axios';

//  config?: {}, // axios 原有的配置项
//  successCodes: [], // 自定义，后端成功时的返回码，每个系统都有可能不同
//  isBasic?: false, // 成功时，是否返回原始信息
//  getToken: null, // 为空，则不会在头部添加 Authorization 字段
//  notice: null, // 接口返回异常时，默认的提示方法
//  mapRes: res => res // 将后端返回，转换成 {code, msg, data} 的标准格式
// }

const defaultArgs = {
  config: {},
  successCodes: [],
  isBasic: true,

  getToken() {
    return '';
  },

  notice() {},

  mapRes(res = {}) {
    return res;
  }

};
const XTECHPATH = 'X-Tech-Path';

function createAxiosInstance(_args = {}) {
  const args = { ...defaultArgs,
    ..._args
  };

  if (!isFunction(args.getToken)) {
    throw new TypeError('args.getToken 需要是一个方法');
  }

  let successCodes = args.successCodes;

  if (!Array.isArray(args.successCodes)) {
    throw new TypeError('args.successCodes 需要是一个数组');
  }

  if (successCodes.length === 0) {
    successCodes = ['000'];
  }

  const notice = args.notice;

  if (!isFunction(notice)) {
    throw new TypeError('args.notice 需要是一个方法');
  }

  const mapRes = args.mapRes;

  if (!isFunction(mapRes)) {
    throw new TypeError('args.mapRes 需要是一个方法');
  }

  const instance = axios.create(args.config);
  instance.interceptors.request.use(config => {
    const token = args.getToken(config);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    addHeader(config);
    return config;
  }, error => {
    notice('请求失败');
    return Promise.reject(error);
  });
  instance.interceptors.response.use(response => {
    let _data = response.data;
    let {
      code,
      msg,
      data
    } = mapRes(_data);

    if (successCodes.indexOf(code) === -1) {
      notice(getErrMsg(_data));
      return Promise.reject(_data);
    } else {
      if (args.isBasic) {
        return data;
      } else {
        return {
          code,
          data,
          msg
        };
      }
    }
  }, error => {
    let statusCode = error.response.status;

    if (statusCode >= 500 && statusCode <= 599) {
      notice('请求失败，请稍后重试一次吧');
    }

    return Promise.reject(error);
  });
  return instance;
}

function isString(str) {
  if (str && typeof str.valueOf() === "string") {
    return true;
  } else {
    return false;
  }
}

function isFunction(func) {
  if (func && typeof func === "function") {
    return true;
  } else {
    return false;
  }
}

function getErrMsg(response = {}, defaultErrorMsg = '请求失败，请稍后再试一次') {
  let errmsg = response.msg;

  if (isString(errmsg) && errmsg.length > 0) {
    return errmsg;
  } else {
    return defaultErrorMsg;
  }
}

function addHeader(config) {
  config.headers[XTECHPATH] = location.href;
}

function create$Http(config = {}, successCodes = ['000'], isBasic = true, mapRes = (res = {}) => res) {
  const TOKEN_COOKIE_NAME = 'userToken';

  function getToken() {
    const cookie = VueCookies.get(TOKEN_COOKIE_NAME);

    if (cookie) {
      let accessToken;

      try {
        accessToken = JSON.parse(cookie).accessToken;
      } catch (e) {
        console.warn(`cookie 值非法: ${cookie}`);
        VueCookies.delete(TOKEN_COOKIE_NAME);
        return;
      }

      return accessToken;
    }
  }

  function notice(msg = '') {
    return Message.error(msg);
  }

  return createAxiosInstance({
    config,
    successCodes,
    isBasic,
    getToken,
    notice,
    mapRes
  });
}

export { create$Http };
//# sourceMappingURL=puma.js.map
